import React from "react";
import Seo from "@/components/Seo";
import PhotoBackdrop from "@/components/PhotoBackdrop";
import Breadcrumb from "@/components/Breadcrumb";
import CTABanner from "@/components/CTABanner";
import Accreditations from "@/components/Accreditations";
import AboutRelated from "@/components/AboutRelated";

// This page reuses the existing Accreditations component (single source of
// truth for badge imagery and copy) so we don't drift from the Home-page
// version. No new claims are introduced.

const AccreditationsPage = () => (
  <div data-testid="about-accreditations-page">
    <Seo
      title="Accreditations"
      description="Lutrom Engineering holds ISO 9001, ISO 14001, ISO 45001, SafeContractor approval, IPAF and City & Guilds credentials. Certificate copies available on request."
      path="/about/accreditations"
    />

    <section className="relative overflow-hidden">
      <PhotoBackdrop src="/gallery/db-panel-3.jpg" position="center 40%" />
      <div className="max-w-7xl mx-auto px-5 lg:px-10 pt-20 lg:pt-28 pb-14 lg:pb-20 relative">
        <p className="eyebrow">About · Accreditations</p>
        <h1
          className="font-display mt-6 text-white"
          style={{ fontSize: "clamp(40px, 5.5vw, 76px)", lineHeight: 0.98 }}
          data-testid="accreditations-heading"
        >
          INDEPENDENTLY
          <br />
          <span className="gradient-blue-text">CERTIFIED &amp; AUDITED.</span>
        </h1>
        <p className="mt-6 max-w-3xl text-[16px] leading-relaxed text-[color:var(--lt-text-dim)]">
          Held to externally audited standards for quality, environment,
          occupational health &amp; safety, powered access and electrical
          competence. Every certificate is available on request.
        </p>
      </div>
    </section>

    <Breadcrumb items={[{ label: "About", to: "/about" }, { label: "Accreditations" }]} />

    <Accreditations />

    <section className="max-w-7xl mx-auto px-5 lg:px-10 mt-20 grid grid-cols-1 lg:grid-cols-12 gap-10">
      <div className="lg:col-span-5">
        <p className="eyebrow">Verification</p>
        <h2
          className="font-display mt-4 text-white"
          style={{ fontSize: "clamp(26px, 3.2vw, 40px)", lineHeight: 1 }}
        >
          CERTIFICATE COPIES
          <br />
          <span className="gradient-blue-text">ON REQUEST.</span>
        </h2>
      </div>
      <div className="lg:col-span-7 space-y-5 text-[15px] leading-relaxed text-[color:var(--lt-text-dim)]">
        <p>
          Numbers, issuing bodies and expiry dates are provided directly to
          prospective clients rather than published on the public site.
        </p>
        <p>
          If your procurement or vendor-onboarding process needs certificate
          scans, competency evidence, or completion of a Pre-Qualification
          Questionnaire (PQQ) covering these standards, email{" "}
          <a
            href="mailto:enquiries@lutrom.co.uk"
            className="text-[color:var(--lt-blue-bright)] hover:underline"
          >
            enquiries@lutrom.co.uk
          </a>{" "}
          — we&apos;ll come back the same working day.
        </p>
        <p>
          Correspondence address: Lutrom Engineering Ltd, Unit 28, Winnington
          Business Park, Winnington Avenue, Northwich, CW8 4DL.
        </p>
      </div>
    </section>

    <CTABanner
      variant="standard"
      title="Need our credentials for a vendor onboarding pack?"
      body="Send us the form or portal invite and we&#39;ll return the completed pre-qualification within one working day."
      phoneLocation="about_accreditations_cta"
    />

    <AboutRelated excludeSlug="accreditations" />
  </div>
);

export default AccreditationsPage;
